/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Receivelist_Pricedrops2Inputs */

const id_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringatan penurunan harga untuk game yang diinginkan`)
};

const ms_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makluman penurunan harga untuk permainan dalam senarai hajat`)
};

const da_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisfaldsalarmer for ønskede spil`)
};

const de_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preissenkungsbenachrichtigungen für Wunschlistenspiele`)
};

const en_us2_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price drop alerts for wishlisted games`)
};

const es_es2_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas de caídas de precio para juegos en tu lista de deseos`)
};

const es_mx2_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas de bajas de precio para juegos en tu lista de deseos`)
};

const fil_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga alerto sa pagbaba ng presyo para sa mga wishlisted na laro`)
};

const fr_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertes de baisse de prix pour les jeux de votre liste de souhaits`)
};

const it_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisi di calo prezzo per i giochi desiderati`)
};

const hu_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áresés figyelmeztetések kívánt játékokhoz`)
};

const nl_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijsdalingmeldingen voor gewenste games`)
};

const no_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prisfallvarsler for ønskede spill`)
};

const pl_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerty o obniżkach cen dla obserwowanych gier`)
};

const pt_br2_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas de queda de preço para jogos da lista de desejos`)
};

const pt_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas de quedas de preço para jogos na lista de desejos`)
};

const ro_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alerte de scădere a prețului pentru jocurile dorite`)
};

const fi_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hälytykset toivelistan pelien hinnanlaskuista`)
};

const sv_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aviseringar om prisfall för önskade spel`)
};

const vi_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cảnh báo giảm giá cho game trong danh sách yêu thích`)
};

const tr_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İstek listenizdeki oyunlar için fiyat düşüş uyarıları`)
};

const cs_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výstrahy na pokles cen u her v seznamu přání`)
};

const bg_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сигнали за спад на цените за желани игри`)
};

const ru_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оповещения о снижении цен на игры из списка желаемого`)
};

const uk_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення про зниження цін для ігор зі списку бажань`)
};

const ar_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنبيهات انخفاض الأسعار للألعاب في قائمة الرغبات`)
};

const hi_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विशलिस्टेड गेम के लिए मूल्य गिरावट अलर्ट`)
};

const th_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือนราคาลดลงสำหรับเกมในรายการที่อยากได้`)
};

const ja_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ウィッシュリストのゲームの値下がりアラート`)
};

const zh_cn2_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`心愿单游戏降价提醒`)
};

const zh_hant1_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`願望清單遊戲降價提醒`)
};

const ko_notifications_receivelist_pricedrops2 = /** @type {(inputs: Notifications_Receivelist_Pricedrops2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`위시리스트 게임 가격 인하 알림`)
};

/**
* | output |
* | --- |
* | "Price drop alerts for wishlisted games" |
*
* @param {Notifications_Receivelist_Pricedrops2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_receivelist_pricedrops2 = /** @type {((inputs?: Notifications_Receivelist_Pricedrops2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Receivelist_Pricedrops2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_receivelist_pricedrops2(inputs)
	if (locale === "ms") return ms_notifications_receivelist_pricedrops2(inputs)
	if (locale === "da") return da_notifications_receivelist_pricedrops2(inputs)
	if (locale === "de") return de_notifications_receivelist_pricedrops2(inputs)
	if (locale === "en-US") return en_us2_notifications_receivelist_pricedrops2(inputs)
	if (locale === "es-ES") return es_es2_notifications_receivelist_pricedrops2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_receivelist_pricedrops2(inputs)
	if (locale === "fil") return fil_notifications_receivelist_pricedrops2(inputs)
	if (locale === "fr") return fr_notifications_receivelist_pricedrops2(inputs)
	if (locale === "it") return it_notifications_receivelist_pricedrops2(inputs)
	if (locale === "hu") return hu_notifications_receivelist_pricedrops2(inputs)
	if (locale === "nl") return nl_notifications_receivelist_pricedrops2(inputs)
	if (locale === "no") return no_notifications_receivelist_pricedrops2(inputs)
	if (locale === "pl") return pl_notifications_receivelist_pricedrops2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_receivelist_pricedrops2(inputs)
	if (locale === "pt") return pt_notifications_receivelist_pricedrops2(inputs)
	if (locale === "ro") return ro_notifications_receivelist_pricedrops2(inputs)
	if (locale === "fi") return fi_notifications_receivelist_pricedrops2(inputs)
	if (locale === "sv") return sv_notifications_receivelist_pricedrops2(inputs)
	if (locale === "vi") return vi_notifications_receivelist_pricedrops2(inputs)
	if (locale === "tr") return tr_notifications_receivelist_pricedrops2(inputs)
	if (locale === "cs") return cs_notifications_receivelist_pricedrops2(inputs)
	if (locale === "bg") return bg_notifications_receivelist_pricedrops2(inputs)
	if (locale === "ru") return ru_notifications_receivelist_pricedrops2(inputs)
	if (locale === "uk") return uk_notifications_receivelist_pricedrops2(inputs)
	if (locale === "ar") return ar_notifications_receivelist_pricedrops2(inputs)
	if (locale === "hi") return hi_notifications_receivelist_pricedrops2(inputs)
	if (locale === "th") return th_notifications_receivelist_pricedrops2(inputs)
	if (locale === "ja") return ja_notifications_receivelist_pricedrops2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_receivelist_pricedrops2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_receivelist_pricedrops2(inputs)
	return ko_notifications_receivelist_pricedrops2(inputs)
});
export { notifications_receivelist_pricedrops2 as "notifications.receiveList.priceDrops" }